export const state = {
  data: {
    // employee
    department: [],
    unit: [],
    position: [],
    recruitment: [],

    // general
    address: [],
    industry: [],

    // fleet
    fleetCategory: [],
    fleetType: [],
    boxType: [],
    thermoType: [],
  },
  status: '',

  // maintenance - parts
  partCategory: [],
}

export const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload
  },
  SET_DATA(state, payload) {
    // employee
    state.data.department = payload.department
    state.data.unit = payload.unit
    state.data.position = payload.position
    state.data.recruitment = payload.recruitment

    // general
    state.data.address = payload.address
    state.data.industry = payload.industry

    // fleet
    state.data.fleetCategory = payload.fleetCategory
    state.data.fleetType = payload.fleetType
    state.data.boxType = payload.boxType
    state.data.thermoType = payload.thermoType
  },
  SET_PARTS(state, payload) {
    state.partCategory = payload
  },
}
